export default "__VITE_ASSET__CKfa_JVD__"